module.exports = __webpack_public_path__ + "assets/img/7_353_big.b55a1b72.jpg";